import { ProductViewModel } from '~/lib/data-contract/auto-generated/product-model';
import { ParamType, Fetch } from '~/lib/models/fetch';
import { runtimeConfig } from '~/shared/utils/public-variables';
import { printQuery } from './utils/print-query';

export type ProductRequestPath = {
    franchiseAPIPath: string;
    productId: string;
    productColorId: string;
};

const { COMMERCE_URL } = runtimeConfig();
/**
 * Helper method for fetching products from product MS
 *
 * @param path The API path without endpoint
 * @param params Additional params for the url
 * @param headers Headers to append
 */
async function commerceFetcher<T>(
    path: string,
    params: ParamType = {},
    headers: HeadersInit = {}
): Promise<Fetch<T>> {
    // Build url
    const url = new URL(path, COMMERCE_URL);

    // Add query params
    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.append(key, String(value));
    });

    printQuery(path, headers);

    const response = await fetch(url.href, {
        method: 'GET',
        headers: {
            ...headers,
            'Content-Type': 'application/json; charset=utf-8',
        },
        keepalive: true,
    });

    const { status, statusText } = response;

    if (status >= 500) {
        console.error(`Failed to fetch CHECKOUT with url:${url}`);
        console.error(statusText);
    }

    return response;
}

/**
 * Fetch product
 */
export async function getProduct({
    franchiseAPIPath,
    productId,
    productColorId,
}: ProductRequestPath) {
    const response = await commerceFetcher<ProductViewModel>(
        `/${franchiseAPIPath}/Product/${productId}/${productColorId}`
    );
    return await response.json();
}
